<template>
  <div v-bind="setting?.attrs">
    <div ref="itemsRef" :class="setting?.listClass">
      <component 
        v-for="item in state.items" 
        :key="item.id" 
        class="goods-item" 
        :data-id="item.id"
        :is="item"
        @update:cart="updateCart"
        @choose:assort="onProductChooseAssort"
      ></component>

      <V3InfiniteLoading 
        :direction="setting.theme == 'theme-4' ? 'right' : ''" 
        :arrived-state="arrivedState" 
        :firstload="false"
        @infinite="loadData"
        >
        <template #complete>
          <span></span>
        </template>
        <template #spinner>
          <span></span>
        </template>
      </V3InfiniteLoading>
    </div>
    <div class="text-danger h1">{{ state.helpText }}</div>
  </div>
</template>
<script setup>
import { reactive, computed, ref, toRaw, onMounted, h } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n"
import { cloneDeep } from "lodash"
import { useScroll } from '@vueuse/core'
import V3InfiniteLoading from "v3-infinite-loading";
import {
  _api_getPromotions,
} from "../../../api/index.js";
import {
  notificationErrors,
  imgProxy,
} from "../../../utils";
import { renderHtml, getAttributesFromNode } from "../../../plugins/html-to-vue/index.js";
import { ElButton, ElImage } from 'element-plus'

const { setting } = defineProps(['setting']);
const emit = defineEmits(["update:cart", "choose:assort"]);

const { t, locale } = useI18n()
const store = useStore();
const { x, y, isScrolling, arrivedState, directions } = useScroll(itemsRef, { behavior: 'smooth' })

// 檢查是否還有商品需要載入
const canLoadMore = computed(() => {
  if (!state.apiData?.paging && state.filterParams?.page > 0) {
    return true
  }
  const dataLen = state.items.length || 0
  if (state.apiData?.paging?.total_count > dataLen && state.filterParams?.page > 0) {
    if (setting.quantity > 0) {
      if (setting.quantity > dataLen) {
        return true;
      }
      return false;
    } else {
      // 不限制數量
      return true;
    }
  }
  return false;
})

const state = reactive({
  apiData: null,
  items: [],
  filterParams: null,
  helpText: null,
})
const itemsRef = ref()
const noneImg = "https://storage.googleapis.com/img.aib.tw/builderjs-editor/static/image/square.png"

const parseTemplate = (rawHtml, item) => {
  const conf = {
    config: {
      container: {
        type: 'div'
      },
      extraComponentsMap: {
        imgLink: {
          conditions(node) {
            return (
              node.type === 'tag' && // is a tag
              node.name === 'div' && // is an anchor
              node.attrs?.class?.match(/goods-img\s?/) // has btn class
            )
          },
          renderer(node, children, context) {
			      const options = getAttributesFromNode(node)
            const image_url = context?.banner_media ? context?.banner_media?.url : noneImg
            // console.debug("imgProxy", imgProxy(image_url, 'fill:300:300:1'))
            let height = setting.template().find(".goods-img").height()
            if (!height) {
              height = 300
            }
            const width = setting.theme == "theme-5" ? height * 2 : height
            // console.debug("imgLink ", width, height)
            return h(
              ElImage,
              {
                class: options.class,
                style: options.style,
                fit: "cover",
                alt: context?.title,
                // loading: 'lazy',
                src: imgProxy(image_url, `fill:${width+50}:${height+50}:1`),
                onClick: (e) => {
                  e.stopPropagation()
                  // console.debug("emit_event", context?.id)
                  if (context?.id) {
                    store.dispatch("lite/setFullPageLoading", true);
                    window.location.assign(`/promotions/${context?.id}`);
                    store.dispatch("lite/setFullPageLoading", false);
                  }
                }
              },
              () => [...children] // parsed children, in our case it will probably be just a text child
            )
          }
        },
      },
      textTransformer: text => text.trim()
    },

    rawHtml: rawHtml,
  }
  return renderHtml(conf.rawHtml, conf.config, item)
}

const setItemTemplate = (item) => {
  let template = setting.template()

  template.attr("data-id", item?.id)
  template.find(".goods-name").text(item?.title)
  template.find('.tag-wrap').html(item.tags);

  // console.debug("item", item)
  return parseTemplate(template.html(), item)
}

const getDatas = async () => {
  if (!state.filterParams?.page) {
    state.helpText = '尚未設定活動來源!';
    return;
  }

  store.dispatch("lite/setFullPageLoading", true);
  try {
    state.apiData = await _api_getPromotions(state.filterParams)
    if (state.apiData.data.length) {
      state.apiData.data.forEach((item) => {
        let template = setItemTemplate(item)
        state.items.push(template)
      })
      state.filterParams.page++

      // console.debug("items", state.items)
      const eventID = state.apiData?.headers?.["x-request-id"] ? state.apiData?.headers?.["x-request-id"] : null
      initTracker(state.apiData.data, eventID)
      // 移除範本
      $(setting.selector()).remove()
    }
  } catch (error) {
    notificationErrors(error);
  } finally {
    store.dispatch("lite/setFullPageLoading", false);
  }
}
const loadData = async ($state) => {
  if (!$state) {
    return
  }
  try {
    // console.debug("canLoadMore", canLoadMore.value)
    if (canLoadMore.value) {
      await getDatas()
      
    }
    if (!canLoadMore.value) {
      console.debug("complete")
      $state.complete()
    } else {
      console.debug("loaded")
      $state.loaded()
    }
    
  } catch (err) {
    $state.error()
    notificationErrors(err)
  } finally {
    // window.fullPageLoading("hide")
  }
}

const initTracker = (items = [], eventID = null) => {
  console.debug("initTracker-多活動組", eventID)

  aibTrackers.viewContentAddonProduct(items, eventID)
  gtmTrackers.viewContentAddonProduct(items, eventID)
  fbqTrackers.viewContentAddonProduct(items, eventID)
  ttqTrackers.viewContentAddonProduct(items, eventID)
  gtagTrackers.viewContentAddonProduct(items, eventID)
}

const updateCart = () => {
  // 重抓購物車
  emit("update:cart")
}
const onProductChooseAssort = (id) => {
  // 開啟選擇規格視窗
  emit("choose:assort", id)
}

onMounted(() => {
  // console.log("setting: ", setting.selector());
  if (setting?.params) {
    state.filterParams = cloneDeep(setting?.params)
  }
  // 移除範本, 僅保留一個當作渲染用
  $(setting.selector()).find('.hide-layout .goods-item').each((index, item) => {
    if (index > 0) {
      $(item).remove()
    }
  })
  $(setting.selector()).find('.hide-nav').remove()
  getDatas()
})
</script>
